import sdl from '@jds/react-generated-sdl/JDSDropdown';
import type { JDSDropdownProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, DropdownProps } from '../logic';

const Component = (props: DropdownProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    open = false,
    disabled = false,
    state = 'undefined',
    ariaLabel = 'Toggle Dropdown',
    _ariaHaspopup = props.open?.toString(),
    _ariaExpanded = props.open?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { open, disabled, state, ariaLabel, _ariaHaspopup, _ariaExpanded, ...rest },
    'JDSDropdown',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const InputDropdown = withLogic(Component) as React.FC<DropdownProps> & {
  slotName?: string;
};

InputDropdown.displayName = 'InputDropdown';
InputDropdown.slotName = 'jds_dropdown';

export { InputDropdown, type JDSDropdownProps };
